<template lang="pug">
#layout(:class='name')
  .wrapper.centered
    .main-panel(:class="{ 'loading' : loading }")
      .auth-layout-wrapper
        .auth-header
        .auth-top
          .container-fluid
            .logo
              img(src='~images/../logo-default.svg', height='44')
        .container
          .row
            .auth-main-body.col-md-4.col-md-offset-4.offset-md-4
              slot
        .container
          .row
            .col-md-4.col-md-offset-4.offser-md-4.text-right
              .logo.partner
                img(src='~images/../logo-default.svg', height='25')
      md-footer
</template>

<script>

import MdFooter from '@/components/Footer'

export default {
  components: {
    MdFooter
  },
  data() {
    return {
      name: 'layout-auth'
    }
  },
  computed: {
    loading() {
      return this.$loading
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.layout-auth .logo.partner {
  img { display: none; }

  margin-top: 15px;
  background-repeat: no-repeat;
  background-image: url(~images/../logo-default.svg);
  background-size: contain;
  background-position: 50% 0;
  width: auto;
  min-height: 30px;
  opacity: .25;
}

// Some Bootstrap Layout Overrides
.container-fluid {
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  padding-left: 1rem;
  padding-right: 1rem;
  transition: all .5s ease-out;
  position: relative;
}

body {
  background-color: $canvas;
  height: 100vh;
}

.logo {
  margin-top: -1rem;
  padding-bottom: .75rem;
}

.auth-layout-wrapper {
  background: $background-light;
  padding-bottom: 1rem;
  height: 100vh;
}

.auth-header {
  width: 100%;
  height: .85rem;
  background: $primary-05;
  padding: 0rem $side-padding;
}

.auth-top {
  width: 100%;
  background: $primary-04;
  padding: 1rem $side-padding;
}

.auth-main-body {
  background: $canvas;
  padding: 1rem;
  border-radius: $border-radius;
  margin-top: -2rem;
  box-shadow: $box-shadow;
}

</style>



// WEBPACK FOOTER //
// auth.vue?7e8998ea